// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 1V4H11V1H13ZM20.4853 4.92848L18.364 7.0498L16.9497 5.63559L19.0711 3.51427L20.4853 4.92848ZM4.9289 3.51431L7.05022 5.63563L5.63601 7.04984L3.51469 4.92852L4.9289 3.51431ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12ZM1 11H4V13H1V11ZM20 11H23V13H20V11ZM7.05024 18.3635L4.92892 20.4848L3.51471 19.0706L5.63603 16.9493L7.05024 18.3635ZM18.3639 16.9493L20.4852 19.0707L19.071 20.4849L16.9497 18.3636L18.3639 16.9493ZM13 20V23H11V20H13Z"}}]};

const SunnyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sunny-filled',
    ref,
    icon: element,
  },
));

SunnyFilledIcon.displayName = 'SunnyFilledIcon';

export default SunnyFilledIcon;
